import { CalSchedule } from '@st/sdk'
import { BellIcon, Tip } from '@st/theme'
import { formatSchedule } from './formatters'
import { formatISO8601Date, ISO8601Time } from '@st/util/time'

export function ReminderScheduleIconButton({
  reminderSchedule,
  onClick
}: {
  reminderSchedule: CalSchedule
  onClick: () => void
}) {
  return (
    <Tip title={formatReminderScheduleTip(reminderSchedule)}>
      <button
        aria-label="Reminder schedule"
        className="rounded-sm bg-gray-200 p-0.5"
        onClick={onClick}
      >
        <BellIcon className="h-3 w-3" />
      </button>
    </Tip>
  )
}

function formatReminderScheduleTip(reminderSchedule: CalSchedule) {
  return (
    'Reminders sent ' +
    formatSchedule(reminderSchedule) +
    '\n' +
    'starting on ' +
    formatISO8601Date(reminderSchedule.firstDate) +
    ' and ending on ' +
    formatISO8601Date(reminderSchedule.lastDate)
  )
}
